import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    SeccionCuestionario: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_SECCIONES_CUESTIONARIO = 'GET_ALL_SECCIONES_CUESTIONARIO'
const GET_SECCION_CUESTIONARIO_BY_ID = 'GET_SECCION_CUESTIONARIO_BY_ID'
const GET_PREGUNTAS_BY_ID_SECCION = 'GET_PREGUNTAS_BY_ID_SECCION'
const POST_SECCION_CUESTIONARIO = 'POST_SECCION_CUESTIONARIO'
const UPDATE_SECCION_CUESTIONARIO = 'UPDATE_SECCION_CUESTIONARIO'
const DELETE_SECCION_CUESTIONARIO = 'DELETE_SECCION_CUESTIONARIO'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllSeccionesCuestionario = createAsyncThunk(
    GET_ALL_SECCIONES_CUESTIONARIO,
    async () => {
        try {
            const fullUrl = host + `SeccionCuestionario/obtenerSeccionesCuestionario`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las SeccionCuestionarios: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getSeccionCuestionarioById = createAsyncThunk(
    GET_SECCION_CUESTIONARIO_BY_ID,
    async (idSeccionCuestionario) => {
        try {
            const fullUrl = host + `SeccionCuestionario/obtenerSeccionCuestionarioById/${idSeccionCuestionario}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertSeccionCuestionario = createAsyncThunk(
    POST_SECCION_CUESTIONARIO,
    async (data) => {
        try {
            const fullUrl = host + `SeccionCuestionario/agregarSeccionCuestionario`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateSeccionCuestionario = createAsyncThunk(
    UPDATE_SECCION_CUESTIONARIO,
    async (data) => {
        try {
            const fullUrl = host + `SeccionCuestionario/actualizarSeccionCuestionario`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteSeccionCuestionario = createAsyncThunk(
    DELETE_SECCION_CUESTIONARIO,
    async (idSeccionCuestionario) => {
        try {
            const fullUrl = host + `SeccionCuestionario/eliminarSeccionCuestionario/${idSeccionCuestionario}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosSeccionCuestionarioSlice = createSlice({

    name: 'metodosSeccionCuestionarioSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllSeccionesCuestionario.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.SeccionCuestionario = payload.data.data

        },
        [getSeccionCuestionarioById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.SeccionCuestionario = payload.data.data
        },
        [insertSeccionCuestionario.fulfilled]: (state, { payload }) => {
            state.SeccionCuestionario = payload.data.data
        },

        [updateSeccionCuestionario.fulfilled]: (state, { payload }) => {

        },
        [deleteSeccionCuestionario.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosSeccionCuestionarioSlice.actions
export const SeccionCuestionarioReducer = metodosSeccionCuestionarioSlice.reducer